import * as React from "react";

function subscribe(onChange: () => void) {
  document.addEventListener("visibilitychange", onChange);
  return () => {
    document.removeEventListener("visibilitychange", onChange);
  };
}

const getSnapshot = () => document.visibilityState === "visible";
const getServerSnapshot = () => true;

export function usePageVisibility(): boolean {
  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
